import { LegalLayout } from "@/components/LegalLayout";
import { LEGAL } from "@/legal/config";

export default function TermsPage() {
  const mail = <a href={`mailto:${LEGAL.supportEmail}`}>{LEGAL.supportEmail}</a>;
  return (
    <LegalLayout title="Terms of Service" subtitle={`Effective ${LEGAL.effectiveDate}`} testId="terms-page">
      <section>
        <p>These terms govern your use of {LEGAL.appName}, operated by {LEGAL.ownerName}. By creating an account you agree to them. If you use {LEGAL.appName} on behalf of a business, you confirm you can bind that business to these terms.</p>
      </section>
      <section>
        <h2>The service</h2>
        <p>{LEGAL.appName} lets you store client records, create and email invoices and receipts, and track expenses. We may improve or change features over time. We aim for high availability but do not guarantee the Service will be uninterrupted or error-free.</p>
      </section>
      <section>
        <h2>Your account</h2>
        <ul>
          <li>Keep your password confidential; you are responsible for activity under your account.</li>
          <li>Provide accurate business information — it is printed on the invoices you send.</li>
          <li>Each account is limited to 120 clients. Contact us if you need more.</li>
        </ul>
      </section>
      <section>
        <h2>Subscription, trial and cancellation</h2>
        <ul>
          <li>New accounts get a <b>14-day free trial</b>. Your card is not charged until the trial ends.</li>
          <li>After the trial, {LEGAL.appName} is billed monthly or yearly in advance through Stripe at the price shown on the Billing page.</li>
          <li>You can cancel any time from the Billing page; you keep access until the end of the paid period. Fees already paid are non-refundable except where required by law.</li>
          <li>Prices may change with at least 30 days' notice; changes apply from your next renewal.</li>
          <li>If payment fails, access to your data is paused until billing is resolved. Your data is not deleted.</li>
        </ul>
      </section>
      <section>
        <h2>Your content and your customers</h2>
        <p>You own the client records, invoices, expenses and files you add. You grant us permission to store and process them only to provide the Service. You are responsible for the accuracy of your invoices, for complying with tax law, and for having a lawful basis to store and email your customers' information. Do not send spam or unsolicited messages through {LEGAL.appName}.</p>
      </section>
      <section>
        <h2>Acceptable use</h2>
        <p>Do not misuse the Service: no fraudulent invoices, no attempts to access other accounts or disrupt the platform, no unlawful content. We may suspend or terminate accounts that violate these terms.</p>
      </section>
      <section>
        <h2>Disclaimer and limitation of liability</h2>
        <p>{LEGAL.appName} is provided "as is". It is a record-keeping and invoicing tool, not tax, legal or accounting advice. To the fullest extent permitted by law, {LEGAL.ownerName} is not liable for indirect or consequential damages, lost profits, or lost data, and our total liability for any claim is limited to the fees you paid in the 12 months before the claim.</p>
      </section>
      <section>
        <h2>Termination</h2>
        <p>You may delete your account at any time from Settings. We may terminate accounts for non-payment or violation of these terms. On termination your data is deleted as described in the <a href="/privacy">Privacy Policy</a>.</p>
      </section>
      <section>
        <h2>Governing law</h2>
        <p>These terms are governed by the laws of {LEGAL.governingLaw}, without regard to conflict-of-law rules.</p>
      </section>
      <section>
        <h2>Contact</h2>
        <p>Questions about these terms: {mail}</p>
      </section>
    </LegalLayout>
  );
}
